import { Type } from 'class-transformer';
import {
  ArrayMaxSize,
  IsArray,
  IsDateString,
  IsEnum,
  IsNumber,
  IsObject,
  IsOptional,
  IsString,
  Max,
  Min,
  ValidateNested,
} from 'class-validator';

import { OrderStatusModel } from './order-status.model';
import {
  MAX_ORDER_SEARCH_ID_COUNT,
  MAX_ORDER_SEARCH_PAGE_SIZE,
  MIN_ORDER_SEARCH_PAGE_SIZE,
} from './search-order.constants';

export class SearchOrderPeriodFilterModel {
  @IsDateString()
  declare from: string;

  @IsOptional()
  @IsDateString()
  declare to: string | undefined;
}
export class SearchOrderFilterModel {
  @IsString()
  declare shopId: string;

  @IsOptional()
  @IsArray()
  @IsString({ each: true })
  declare placeIds: string[] | undefined;

  @IsArray()
  @IsEnum(['PENDING', 'CONFIRMED', 'READY', 'REJECTED', 'CLOSED', 'REFUNDED'], {
    each: true,
  })
  declare status: OrderStatusModel[];

  @IsObject()
  @ValidateNested()
  @Type(() => SearchOrderPeriodFilterModel)
  declare period: SearchOrderPeriodFilterModel;

  @IsOptional()
  @IsArray()
  @IsNumber(undefined, { each: true })
  @ArrayMaxSize(MAX_ORDER_SEARCH_ID_COUNT)
  declare orderIds?: number[] | undefined;

  @IsOptional()
  @IsArray()
  @IsNumber(undefined, { each: true })
  @ArrayMaxSize(MAX_ORDER_SEARCH_ID_COUNT)
  declare verificationIds?: number[] | undefined;
}

export class SearchOrderModel {
  @IsObject()
  @ValidateNested()
  @Type(() => SearchOrderFilterModel)
  declare filter: SearchOrderFilterModel;
}

export class SearchOrderPageModel {
  @IsObject()
  @ValidateNested()
  @Type(() => SearchOrderFilterModel)
  declare filter: SearchOrderFilterModel;

  @IsOptional()
  @IsNumber()
  @Min(MIN_ORDER_SEARCH_PAGE_SIZE)
  @Max(MAX_ORDER_SEARCH_PAGE_SIZE)
  declare pageSize: number | undefined;

  @IsOptional()
  @IsString()
  declare pageToken: string | undefined;
}
